// On met la limite max de chaque fichier ici -> 500MB
export const MAX_FILE_SIZE = 500 * 1024 * 1024;

export const acceptedImageFormats = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/bmp",
  "image/gif",
  "image/webp",
  "application/pdf",
];
export const acceptedVideoFormats = [
  "video/mp4",
  "video/avi",
  "video/mov",
  "video/flv",
  "video/quicktime",
];
export const validatesFormatAndSize = (
  files: File[],
  type: "image" | "video" | "all" = "all"
) => {
  const acceptedFormats =
    type === "all"
      ? [...acceptedImageFormats, ...acceptedVideoFormats]
      : type === "image"
      ? acceptedImageFormats
      : acceptedVideoFormats;
  const forbiddenFiles = Array.from(files ?? []).filter(
    (file) => !acceptedFormats.includes(file.type) || file.size > MAX_FILE_SIZE
  );
  if (forbiddenFiles.length > 0) {
    alert(
      `Les fichiers suivants ne sont pas autorisés : ${forbiddenFiles
        .map((f) => f.name)
        .join(", ")}`
    );
  }
  return forbiddenFiles;
};
